import React, { Fragment, Component } from 'react';
import './App.css';
import {Router, Route} from "react-router-dom";
import 'antd/lib/style/index.css'
import Home from './routes/home/Home'
import My from './routes/user/User'
import Post from './routes/post/Post'
import history from './history'

class App extends Component {
  render() {
    return <Router history={ history }>
      <Fragment>
        <Route exact path="/" component={Home} />
        <Route exact path="/users/:_id" component={My} />
        <Route exact path="/posts/:_id" component={Post} />
      </Fragment>
    </Router>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js